// extracted by mini-css-extract-plugin
module.exports = {"protichinta-logo":"desktopLogo-m__protichinta-logo__1wvpO"};